import React, { useRef, useEffect, useState } from 'react';
import Button from '@mui/material/Button';
import Dialog from '@mui/material/Dialog';
import DialogActions from '@mui/material/DialogActions';
import DialogContent from '@mui/material/DialogContent';
import DialogTitle from '@mui/material/DialogTitle';
import Slide from '@mui/material/Slide';
import TextField from '@mui/material/TextField';

import Snackbar from '@mui/material/Snackbar';
import MuiAlert from '@mui/material/Alert';
import { userNameHandler, roleHandler } from '../../util/local-storage';
import { posWashing } from './hook/usePosApi'


const Transition = React.forwardRef(function Transition(props, ref) {
    return <Slide direction="up" ref={ref} {...props} />;
});


const RejectOrderModal: React.FC = (props) => {


    const userloginName = useState(userNameHandler.get())[0];
    const userRole = useState(roleHandler.get())[0];
    const [display, setDisplay] = useState(props);
    const [btnSubmit, setBtnSubmit] = useState(false);

    const [notifyMessage, setNotifyMessage] = useState("");
    const [typeNotify, setTypeNotify] = useState('');
    const [openNotify, setNotify] = useState(false);
    const eRemark = useRef();

    const handleClose = (event, reason) => {

        if (reason && reason == "backdropClick" && "escapeKeyDown")
            return;

        if (props.onClose != null) {
            props.onClose(false);
        }
        setDisplay({ ...props, isDisplay: false });
    };


    const Alert = React.forwardRef(function Alert(props, ref) {
        return <MuiAlert elevation={6} ref={ref} variant="filled" {...props} />;
    });

    const handleNotify = (event, reason) => {
        if (reason === 'clickaway') {
            return;
        }
        setNotify(true);
    };


    const onSubmit = (e) => {
        e.preventDefault();
        setBtnSubmit(true);
        let remark = eRemark.current.value;

        if (remark == '') {
            setNotifyMessage('กรุณาระบุเหตุผล');
            setTypeNotify('error')
            handleNotify();
            setBtnSubmit(false);
        }
        else {
            var body = {
                "service_No": props.orderNo,
                "service_Type": "WDF",
                "status": "REJ",
                "userLogin": userloginName,
                "remark": eRemark.current.value
            };


            posWashing(body).then(function (response) {
                setNotifyMessage('บันทึกสำเร็จ');
                setTypeNotify('success');
                handleNotify();
                handleClose();
                window.location.reload();
            }).catch(function () {
                setNotifyMessage('บันทึกไม่สำเร็จ กรุณาลองอีกครั้ง');
                setTypeNotify('error')
                handleNotify();
                setBtnSubmit(false);
            });
        }

    };


    const handleCloseDialog = (event, reason) => {
        if (reason === 'clickaway') {
            return;
        }
        setNotify(false);
    };

    useEffect(() => {
        setDisplay(props);
        setBtnSubmit(false);
    }, [props.isDisplay]);


    return (
        <div>
            {/* <div style={{ display: loadingPageFlag === 1 ? 'block' : 'none' }}   >
                <LoadingPage />
            </div> */}
            <Dialog
                open={display.isDisplay}
                onClose={handleClose}
                aria-labelledby="alert-dialog-title"
                aria-describedby="alert-dialog-description"
                maxWidth="sm"
                fullWidth={true}
            >
                <DialogTitle className='border-b-2'>
                    {"ยกเลิกรายการ"} {props.orderNo}
                </DialogTitle>
                <DialogContent className='m-4 h-56 '>

                    <TextField label="Remark" className='m-4'
                        multiline fullWidth
                        rows={5}
                        maxRows={5} inputRef={eRemark}></TextField>


                </DialogContent>
                <DialogActions className='border-t-2'>
                    <Button variant="contained" color='error' onClick={handleClose}>Cancel</Button>
                    <Button variant="contained" color='primary' disabled={btnSubmit} onClick={(event) => onSubmit(event)} autoFocus>
                        Submit
                    </Button>
                </DialogActions>
            </Dialog>

            <Snackbar open={openNotify} autoHideDuration={6000} onClose={handleCloseDialog} anchorOrigin={{ vertical: 'top', horizontal: 'right' }}
                key={"top" + "center"}>
                <Alert onClose={handleCloseDialog} severity={typeNotify} sx={{ width: '100%' }}>
                    {notifyMessage}
                </Alert>
            </Snackbar>

        </div>
    );

}

export default RejectOrderModal;